import axios from 'axios'
import { UrlApi, authMail, authPass } from '../Keys'
import { toast } from "react-toastify"
import moment from "moment"

const dataInicial = {
    trayectoria: [],
    loadingTrayectoria: false,
    creacion: '',
    creacionId: '',
    modificacion: 'EXITO',
    loadingActualizacion: false
}

const LOADING_TRAYECTORIA = 'LOADING_TRAYECTORIA'
const TRAYECTORIA = 'TRAYECTORIA'
const TRAYECTORIA_ERROR = 'TRAYECTORIA_ERROR'

const CREAR_TRAYECTORIA_EXITO = 'CREAR_TRAYECTORIA_EXITO'
const CREAR_TRAYECTORIA_ERROR = 'CREAR_TRAYECTORIA_ERROR'

const ACTUALIZACION_EXITO = 'ACTUALIZACION_EXITO'
const ACTUALIZACION_ERROR = 'ACTUALIZACION_ERROR'

//Reducers
export default function trayectoriaReducer(state = dataInicial, action) {
    switch (action.type) {
        case TRAYECTORIA:
            return { ...state, trayectoria: action.payload, loadingTrayectoria: action.loadingTrayectoria }
        case LOADING_TRAYECTORIA:
            return { ...state, loadingTrayectoria: action.loadingTrayectoria }
        case CREAR_TRAYECTORIA_EXITO:
            return { ...state, creacionId: action.payload, creacion: action.creacion }
        case ACTUALIZACION_EXITO:
            return { ...state, modificacion: action.modificacion }
        default:
            return { ...state }
    }
}

export const trayectoriaDocente = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_TRAYECTORIA,
        loadingTrayectoria: true
    })

    try {
        var entidad = "new_trayectoriadocentes"
        var fetch =
            "<entity name='new_trayectoriadocente'>" +
            "<attribute name='new_fechadeinicio'/>" +
            "<attribute name='new_fechadefinalizacin'/>" +
            "<attribute name='new_designacin'/>" +
            "<attribute name='new_dedicacinsemanal'/>" +
            "<attribute name='new_cargo'/>" +
            "<attribute name='new_institucinacadmica'/>" +
            "<attribute name='new_unidadacadmica'/>" +
            "<attribute name='new_duracindelcursado'/>" +
            "<attribute name='new_trayectoriadocenteid'/>" +
            "<attribute name='new_tipodetrayectoria'/>" +
            "<order attribute='new_fechadeinicio' descending='true'/>" +
            "<filter type='and'>" +
            "<condition attribute='statecode' operator='eq' value='0'/>" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_empleado' link-type='inner' alias='ag'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "'/>" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: TRAYECTORIA,
            payload: response.data,
            loadingTrayectoria: false
        })
    }
    catch (error) {
        dispatch({
            type: TRAYECTORIA_ERROR,
            loadingTrayectoria: false
        })
    }
}

export const crearTrayectoria = (empleado, objeto, token) => async (dispatch) => {
    const { new_tipodetrayectoria, new_institucinacadmica, new_funcion, new_designacin,new_fechadeinicio,
        new_duracindelcursado, new_disciplina, new_subdisciplina, new_cargo, new_unidadacadmica, new_otrocargofuncin,
        new_fechadefinalizacin, new_dedicacinsemanal
    } = objeto;

    // var fecha = new_fecha
    return toast.promise(
        new Promise((resolve, reject) => {
            axios.post(
                `${UrlApi}api/hrfactors/trayectoriadocente`,
                {
                    "new_empleado": empleado,
                    "new_tipodetrayectoria": new_tipodetrayectoria,
                    "new_institucinacadmica": new_institucinacadmica.value,
                    "new_funcion": new_funcion,
                    "new_designacin": new_designacin,
                    "new_fechadeinicio": moment(new_fechadeinicio).format('YYYY-MM-DD'),
                    "new_duracindelcursado": new_duracindelcursado,
                    "new_disciplina": new_disciplina.value,
                    "new_subdisciplina": new_subdisciplina.value,
                    "new_cargo": new_cargo,
                    "new_unidadacadmica": new_unidadacadmica,
                    "new_otrocargofuncin": new_otrocargofuncin,
                    "new_fechadefinalizacin": moment(new_fechadefinalizacin).format('YYYY-MM-DD'),
                    "new_dedicacinsemanal": new_dedicacinsemanal
                  },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    dispatch({
                        type: CREAR_TRAYECTORIA_EXITO,
                        payload: response.data,
                        creacion: "EXITO",
                    });
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);

                    dispatch({
                        type: CREAR_TRAYECTORIA_ERROR,
                        creacion: "ERROR",
                    });
                    reject(error);
                });
        }),
        {
            pending: "Procesando...",
            success: "Trayectoria docente creada con éxito!",
            error: {
                render({ data }) {
                    return `${data}`;
                },
            },
        },
        {
            theme: "dark",
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    )
};

export const actualizarCantidades = (token, objeto, id) => async (dispatch) => {
    debugger
    const {
        new_cantidadtotaldetesis, 
        new_canttesisdoctoralesdirigactualmente, 
        new_canttesismaestriasdirigyconcult, 
        new_cantmaestriasquedirigeactualmente,
        new_canttesinasytrabfinales,
        new_canttesinasytrabajosquedirigeactualmente,
        new_experienciaeneducacinadistancia
    } = objeto

    try {
        const update = () => new Promise(async (resolve, reject) => {
            await axios.put(`${UrlApi}api/hrfactors/areaacademica`,
                {
                    "new_empleadoid": id,
                    "new_cantidadtotaldetesis": new_cantidadtotaldetesis,
                    "new_canttesisdoctoralesdirigactualmente": new_canttesisdoctoralesdirigactualmente,
                    "new_canttesismaestriasdirigyconcult": new_canttesismaestriasdirigyconcult,
                    "new_cantmaestriasquedirigeactualmente": new_cantmaestriasquedirigeactualmente,
                    "new_canttesinasytrabfinales": new_canttesinasytrabfinales,
                    "new_canttesinasytrabajosquedirigeactualmente": new_canttesinasytrabajosquedirigeactualmente,
                    "new_experienciaeneducacinadistancia": new_experienciaeneducacinadistancia,
                },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            ).then((response) => {
                dispatch({
                    type: ACTUALIZACION_EXITO,
                    modificacion: 'EXITO',
                    loadingActualizacion: false
                })
                resolve(response.data)
            })
                .catch(err => {
                    reject(err)
                    console.log(err)
                })
        })

        const response = await toast.promise(
            update,
            {
                pending: 'Procesando...',
                success: 'Actualización con éxito!',
                error: {
                    render({ data }) {
                        // console.log(data)
                        return `${data}`
                    }
                }
            },
            {
                theme: "dark",
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            }
        )
    } catch (error) {
        console.log(error)
        dispatch({
            type: ACTUALIZACION_ERROR,
            modificacion: 'ERROR',
            loadingActualizacion: false
        })
    }
}